const videoTestimonials = [
  {
    id: "g9OCIOvHAsQ",
    title: "Learning Experience at IA4Solutions",
    featured: true,
    youtubeUrl: "https://www.youtube.com/shorts/g9OCIOvHAsQ",
  },
  {
    id: "7qYsKjh_CFM",
    title: "Training Experience at IA4Solutions",
    featured: true,
    youtubeUrl: "https://www.youtube.com/shorts/7qYsKjh_CFM",
  },
  {
    id: "vlp6H9aOWeA",
    title: "Student Journey at IA4Solutions",
    featured: true,
    youtubeUrl: "https://www.youtube.com/shorts/vlp6H9aOWeA",
  },
  {
    id: "bhJzXabate8",
    title: "Practical Learning Experience",
    featured: false,
    youtubeUrl: "https://www.youtube.com/shorts/bhJzXabate8",
  },
  {
    id: "VvAT318PseQ",
    title: "Training & Skill Development",
    featured: false,
    youtubeUrl: "https://www.youtube.com/shorts/VvAT318PseQ",
  },
  {
    id: "_pi5yM4JxKY",
    title: "Student Learning Journey",
    featured: false,
    youtubeUrl: "https://www.youtube.com/shorts/_pi5yM4JxKY",
  },
  {
    id: "NMnkvvApb6I",
    title: "Career & Learning Experience",
    featured: false,
    youtubeUrl: "https://www.youtube.com/shorts/NMnkvvApb6I",
  },
  {
    id: "Pj22Fqvhma0",
    title: "Student Experience at IA4Solutions",
    featured: false,
    youtubeUrl: "https://www.youtube.com/shorts/Pj22Fqvhma0",
  },
];

export default videoTestimonials;